// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"00ca577e","102":"00ca577e","122":"00ca577e","225":"d05b4957","746":"d05b4957","978":"00ca577e"}[chunkId] + ".chunk.css";
};